import React from "react";
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import FormLogin from '../../../components/forms/logins/FormLogin';
import { getTraducaoTrocaPor as trad, getCampoTraducao as tradCampo } from '../../../utils/getTraducoes';


function CompLoginModal(props) {
  return (
    <Modal {...props} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {trad(props.trads, 'ENTRAR', props.language)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormLogin />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>{trad(props.trads, 'FECHAR', props.language)}</Button>
      </Modal.Footer>
    </Modal>
  );
}


const mapStateToProps = (state) => {
  return {
    trads: state.reducerTraducoes
  };
}
export default connect(mapStateToProps)(CompLoginModal);

